import React from "react";
import direction from "../../../service/direction.json";
const DescriptionRegister = () => {
  return (
    <div className="form-group row col-md-12 text-justify">
      <div className="col-md-6">
        ابتدا سامانه پیامک را مشاهده کرده، سپس هزینه آن را پرداخت کنید!
        <br />
        <p />
        بعد از اینکه پنل موردنظر را انتخاب و ثبت نام کردید پنل شما بلافاصله
        ایجاد و قابل دسترسی میباشد.
        <br />
        <br />
        <br />
        <br />
        ابتدا وارد محیط سامانه پیام کوتاه شده و بعد از مشاهده و بررسی نسبت به
        پرداخت هزینه از داخل پنل اقدام کنید.
        <br />
        ارسالهای بسیار بالایی دارید؟ پکیج های سازمانی برای شما باصرفه تر خواهند
        بود
        <br />
        پنل کاربری سازمانی: بدون اجبار به شارژ زیاد، پیامک ها را ۵% ارزانتر از
        پنل ویژه ارسال کنید (حق اشتراک سالانه)
        <br />
        <br />
        جهت اطلاع از شرایط دقیق پنل های کاربری سازمانی تماس بگیرید{" "}
        <a href="tel:09053638893">09053638893</a> -
        <a href="tel:09198362447">09198362447</a>
        <br />
        <br />
        <br />
        <div className="alert alert-success" role="alert">
          تا 10 روز بعد از خرید پنل اس ام اس درصورت عدم رضایت میتوانید درخواست
          عودت وجه نمایید!
        </div>
      </div>
      <p />
      <div className="col-md-6 text-center">
        <img src={`${direction.ImgDesign}sazmani.png`} alt="سایه بان" />
        <br />
        <br />
        <a
          href="http://sms.sayyehban.ir/register.jspd"
          className="btn btn-info"
        >
          همین الان ثبت نام کن
        </a>
      </div>
    </div>
  );
};

export default DescriptionRegister;
